import React, { useEffect, useState } from "react";
import axios from "axios";
import DashboardLayout from "./DashboardLayout";
import html2pdf from "html2pdf.js";
import { RUNTIME_PUBLIC_BASE } from "../utils/runtimeBase";

function NewFranchise() {

  const API = RUNTIME_PUBLIC_BASE || "";

  const [data, setData] = useState([]);
  const [selected, setSelected] = useState(null);

  const [showAction, setShowAction] = useState(false);
  const [showView, setShowView] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState({});
  const [editFiles, setEditFiles] = useState({});
  const [editPreviews, setEditPreviews] = useState({});
  const [brokenPreviews, setBrokenPreviews] = useState({});
  const [states, setStates] = useState([]);
  const [districts, setDistricts] = useState([]);
  const [academyCategories, setAcademyCategories] = useState([]);

const imageToDataUrl = async (src) => {
  if (!src || src.startsWith("data:")) return src;
  const fileName = decodeURIComponent(String(src).split("/").pop().split("?")[0]);
  const response = await axios.get(`${API}/api/upload-data-url`, {
    params: { file: fileName, _ts: Date.now() },
  });
  return response.data?.data_url || src;
};

const preparePrintableClone = async () => {
  const original = document.querySelector(".print-area");
  if (!original) return null;

  const element = original.cloneNode(true);
  const images = Array.from(element.querySelectorAll("img"));

  await Promise.all(images.map(async (img) => {
    try {
      img.setAttribute("crossorigin", "anonymous");
      img.src = await imageToDataUrl(img.src);
      await new Promise((resolve) => {
        const testImage = new Image();
        testImage.onload = resolve;
        testImage.onerror = resolve;
        testImage.src = img.src;
      });
    } catch (err) {
      console.log("Image prepare error:", err);
    }
  }));

  return element;
};

const handleDownload = async () => {
  const preparedElement = await preparePrintableClone();
  if (!preparedElement) return;

  // 🔥 clone node (original change হবে না)
  const element = preparedElement;

  const images = element.querySelectorAll("img");

  // 🔥 convert images
  for (let img of images) {
    try {
      const response = await fetch(img.src);
      const blob = await response.blob();

      const reader = new FileReader();

      await new Promise(resolve => {
        reader.onloadend = () => {
          img.src = reader.result;
          resolve();
        };
        reader.readAsDataURL(blob);
      });

    } catch (err) {
      console.log("Image error:", err);
    }
  }

  const opt = {
    margin: 10,
    filename: "franchise_application.pdf",
    image: { type: "jpeg", quality: 1 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      allowTaint: true
    },
    jsPDF: {
      unit: "mm",
      format: "a4",
      orientation: "portrait"
    }
  };

  html2pdf().set(opt).from(element).save();
};

const handlePrint = async () => {
  const element = await preparePrintableClone();
  if (!element) return;

  // 🔥 wait for images
  const images = element.querySelectorAll("img");

  await Promise.all(
    Array.from(images).map(img => {
      return new Promise(resolve => {
        if (img.complete) {
          resolve();
        } else {
          img.onload = resolve;
          img.onerror = resolve;
        }
      });
    })
  );

  const printContents = element.innerHTML;

  const newWindow = window.open("", "", "width=800,height=900");

  newWindow.document.write(`
    <html>
      <head>
        <title>Print</title>
        <style>
          body { font-family: serif; padding: 20px; }
          img { max-width: 100%; }
          table { width: 100%; border-collapse: collapse; }
          table, td { border: 1px solid #000; padding: 5px; }
        </style>
      </head>
      <body>
        ${printContents}
      </body>
    </html>
  `);

  newWindow.document.close();

  const printImages = Array.from(newWindow.document.images);
  await Promise.all(printImages.map((img) => new Promise((resolve) => {
    if (img.complete) {
      resolve();
      return;
    }
    img.onload = resolve;
    img.onerror = resolve;
  })));

  // 🔥 delay for render
  setTimeout(() => {
  newWindow.focus();
  newWindow.print();
  }, 250);
};


  


  // 🔥 MODAL STYLE FIX
const modalStyle = {
  position: "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  background: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  zIndex: 9999
};

const modalContent = {
  background: "#fff",
  padding: "20px",
  borderRadius: "10px",
  width: "500px",
  maxHeight: "90vh",
  overflowY: "auto"
};



  // 🔥 LOAD DATA
  const fetchData = () => {
    axios.get(`${API}/api/franchise-applications`, {
      params: { _ts: Date.now() },
    })
      .then(res => setData((res.data || []).filter((item) => item.status !== "approved")));
  };

  useEffect(() => {
    fetchData();
  }, []);

  // 🔥 APPROVE
  const approve = async (id) => {
  try {
    const res = await axios.post(`${API}/api/franchise-approve/${id}`);

    if (res.data.status === "re-approved") {
      alert("Re-Approved ✅\nCode: " + res.data.code);
    } else {
      alert("Approved ✅\nCode: " + res.data.code);
    }

    // 🔥 CLOSE MODAL
    setShowAction(false);
    setSelected(null);

    fetchData();

  } catch (err) {
    alert(err.response?.data?.error || "Error");

    // 🔥 FIX
    setShowAction(false);
    setSelected(null);
  }
};

  // 🔥 STATUS UPDATE
  const updateStatus = async (id, status) => {
  try {
    await axios.post(`${API}/api/franchise-status/${id}`, { status });

    alert("Status Updated");

    setShowAction(false);
    setSelected(null);

    fetchData();

  } catch (err) {
    alert("Error");

    setShowAction(false);
    setSelected(null);
  }
};

  // 🔥 EDIT CHANGE
  const handleEditChange = (e) => {
    setEditData({
      ...editData,
      [e.target.name]: e.target.value
    });
  };

  const handleEditFile = (e) => {
    const { name, files } = e.target;
    const file = files?.[0] || null;
    setEditFiles((prev) => ({
      ...prev,
      [name]: file,
    }));
    if (file) {
      setBrokenPreviews((prev) => ({ ...prev, [name]: false }));
      const reader = new FileReader();
      reader.onload = () => {
        setEditPreviews((prev) => ({ ...prev, [name]: reader.result }));
      };
      reader.readAsDataURL(file);
    }
  };

  const uploadUrl = (fileName) => {
    if (!fileName) return "";
    const raw = String(fileName).trim();
    if (/^https?:\/\//i.test(raw) || raw.startsWith("data:")) return raw;
    const normalized = raw.replace(/\\/g, "/");
    const path = normalized.includes("/uploads/")
      ? normalized.substring(normalized.indexOf("/uploads/"))
      : normalized.startsWith("uploads/")
      ? `/${normalized}`
      : `/uploads/${normalized}`;
    return `${API}${path}`;
  };

  const uploadCandidates = (fileName) => {
    if (!fileName) return [];
    const raw = String(fileName).trim().replace(/\\/g, "/");
    const base = raw.split("/").pop();
    const candidates = [
      uploadUrl(raw),
      `${API}/uploads/${base}`,
      `${API}/uploads/franchise/${base}`,
      `${API}/uploads/franchise-applications/${base}`,
      `${API}/uploads/documents/${base}`,
    ];
    return [...new Set(candidates)];
  };

  const isImageFile = (name = "") => {
    return /\.(jpg|jpeg|png|webp|gif|bmp|svg)$/i.test(String(name));
  };

  // 🔥 UPDATE DATA
  const updateData = async () => {
    const formData = new FormData();

    Object.keys(editData).forEach(key => {
      if (editData[key] !== undefined && editData[key] !== null) {
        formData.append(key, editData[key]);
      }
    });

    Object.entries(editFiles).forEach(([key, file]) => {
      if (file) formData.append(key, file);
    });

    await axios.post(`${API}/api/franchise-update/${editData.id}`, formData);

    alert("Updated Successfully");

    setShowEdit(false);
    setEditFiles({});
    setEditPreviews({});
    setBrokenPreviews({});
    fetchData();
  };

  return (
    <DashboardLayout>

      <div className="container-fluid">

        <div className="d-flex flex-wrap justify-content-between align-items-center gap-3 mb-4">
          <div>
            <div className="text-uppercase fw-semibold text-primary" style={{ fontSize: "12px", letterSpacing: "0" }}>
              Franchise Management
            </div>
            <h3 className="mb-0">Applied Franchise</h3>
          </div>
          <span className="badge bg-light text-dark border">{data.length} Records</span>
        </div>

        {/* 🔥 TABLE */}
        <div className="bg-white border shadow-sm" style={{ borderRadius: "8px", overflow: "hidden" }}>
          <div
            className="px-3 py-2 d-flex justify-content-between align-items-center"
            style={{ background: "linear-gradient(90deg, #ecfeff 0%, #f0fdf4 55%, #fff7ed 100%)", borderBottom: "1px solid #bae6fd" }}
          >
            <strong style={{ color: "#0f172a" }}>Applied List</strong>
            <span className="badge bg-light text-dark border">{data.length} Records</span>
          </div>
          <div className="table-responsive" style={{ maxWidth: "100%", overflowX: "auto" }}>
        <table className="table table-hover table-bordered align-middle mb-0" style={{ tableLayout: "fixed", width: "100%", minWidth: "760px", borderColor: "#cbd5e1" }}>

          <thead style={{ background: "linear-gradient(90deg, #0f766e 0%, #2563eb 52%, #7c3aed 100%)", color: "#fff" }}>
            <tr>
              <th className="text-center" style={{ width: "72px", height: "54px" }}>Sl. No.</th>
              <th className="text-center" style={{ width: "220px", height: "54px" }}>Institute</th>
              <th className="text-center" style={{ width: "170px", height: "54px" }}>Location</th>
              <th className="text-center" style={{ width: "140px", height: "54px" }}>Mobile</th>
              <th className="text-center" style={{ width: "130px", height: "54px" }}>Status</th>
              <th className="text-center" style={{ width: "210px", height: "54px" }}>Action</th>
            </tr>
          </thead>

          <tbody>
            {data.map((item, index) => (
              <tr key={item.id} style={{ background: index % 2 === 0 ? "#ffffff" : "#f8fafc" }}>
                <td className="text-center fw-semibold" style={{ height: "74px" }}>
                  <span className="badge rounded-pill" style={{ background: "#e0f2fe", color: "#0369a1", border: "1px solid #7dd3fc" }}>
                    {index + 1}
                  </span>
                </td>
                <td className="text-center" style={{ height: "74px", whiteSpace: "normal", wordBreak: "break-word" }}>
                  <b style={{ color: "#1e40af" }}>{item.institute_name}</b>
                  {item.application_no ? (
                    <>
                      <br />
                      <span className="badge px-3 py-2 mt-1" style={{ background: "#eef2ff", color: "#3730a3", border: "1px solid #c7d2fe" }}>
                        {item.application_no}
                      </span>
                    </>
                  ) : null}
                </td>
                <td className="text-center" style={{ height: "74px", whiteSpace: "normal", wordBreak: "break-word" }}>
                  <span className="badge border" style={{ background: "#fef3c7", color: "#92400e", borderColor: "#fbbf24" }}>
                    {item.state_name || "N/A"}
                  </span><br/>
                  <small style={{ color: "#475569" }}>{item.district_name || "N/A"}</small>
                </td>
                <td className="text-center" style={{ height: "74px", whiteSpace: "normal", wordBreak: "break-word" }}>
                  <span className="fw-bold px-2 py-1 rounded" style={{ color: "#be123c", background: "#fff1f2" }}>{item.contact}</span>
                </td>

                <td className="text-center" style={{ height: "74px" }}>
                  <span className="badge" style={{
                    background: item.status === "approved" ? "#16a34a" : item.status === "rejected" ? "#dc2626" : item.status === "hold" ? "#facc15" : "#64748b",
                    color: item.status === "hold" ? "#713f12" : "#ffffff",
                    boxShadow: "0 4px 10px rgba(15,23,42,0.12)"
                  }}>
                    {item.status ? item.status.charAt(0).toUpperCase() + item.status.slice(1) : "Pending"}
                  </span>
                </td>

                <td className="text-center" style={{ height: "74px" }}>
                  <div className="d-flex flex-wrap justify-content-center gap-1">

                  {/* VIEW */}
                  <button
                    className="btn btn-info btn-sm"
                    onClick={() => {
                      setSelected(item);
                      setShowView(true);
                    }}
                  >
                    View
                  </button>

                  {/* EDIT */}
                  <button
                    className="btn btn-warning btn-sm"
                    onClick={async () => {
                      setEditData(item);
                      setShowEdit(true);
                      setEditFiles({});
                      setEditPreviews({});
                      setBrokenPreviews({});
                      try {
                        const [stateRes, districtRes, categoryRes] = await Promise.all([
                          axios.get(`${API}/api/states`),
                          axios.get(`${API}/api/districts`),
                          axios.get(`${API}/api/academy-categories`),
                        ]);
                        setStates(stateRes.data || []);
                        setDistricts(districtRes.data || []);
                        setAcademyCategories(categoryRes.data || []);
                      } catch (error) {}
                    }}
                    title="Edit Application"
                  >
                    <i className="bi bi-pencil-square"></i>
                  </button>

                  {/* ACTION */}
                  <button
                    className="btn btn-primary btn-sm"
                    onClick={() => {
                      setSelected(item);
                      setShowAction(true);
                    }}
                  >
                    Action
                  </button>
                  </div>

                </td>
              </tr>
            ))}
          </tbody>

        </table>
          </div>
        </div>

        {/* 🔥 VIEW MODAL */}
        {showView && selected && (
  <div
    style={modalStyle}
    onClick={() => {
      setShowView(false);
      setSelected(null);
    }}
  >
    <div
      style={{ ...modalContent, width: "850px" }}
      onClick={(e) => e.stopPropagation()}
    >

      <div
        className="print-area"
        style={{ padding: "25px", fontFamily: "serif", lineHeight: "1.6" }}
      >

        {/* HEADER */}
        <div style={{ display: "flex", justifyContent: "space-between" }}>
          <div>
            <p>To,</p>
            <p><b>The NIDCS Higher Authority</b></p>
            <p>NIDCS Head Office</p>
            <p>Srichandrapur, Bankura</p>
          </div>

          {selected.photo && (
            <img
              src={`${API}/uploads/${selected.photo}`}
              style={{
                width: "120px",
                height: "120px",
                objectFit: "cover",
                border: "2px solid #ddd",
                borderRadius: "8px"
              }}
            />
          )}
        </div>

        <hr />

        <p><b>Subject:</b> Application for Franchise Approval</p>

        <p>
          Respected Sir/Madam,<br /><br />
          I hereby submit my application for obtaining a franchise under NIDCS.
          The details are given below:
        </p>

        {/* DETAILS */}
        <h6 className="fw-bold mt-3">Institute Details</h6>

        <table className="table table-bordered table-sm" style={{ borderColor: "#cbd5e1" }}>
          <tbody>
            <tr><td>Institute Name</td><td>{selected.institute_name}</td></tr>
            <tr><td>Apply For</td><td>{selected.apply_for}</td></tr>
            <tr><td>State</td><td>{selected.state_name}</td></tr>
            <tr><td>District</td><td>{selected.district_name}</td></tr>
            <tr><td>City</td><td>{selected.city}</td></tr>
            <tr><td>Address</td><td>{selected.address}</td></tr>
            <tr><td>Pincode</td><td>{selected.pincode}</td></tr>
            <tr><td>Contact</td><td>{selected.contact}</td></tr>
            <tr><td>Email</td><td>{selected.email}</td></tr>
          </tbody>
        </table>

        <h6 className="fw-bold mt-3">Centre Incharge</h6>

        <table className="table table-bordered table-sm" style={{ borderColor: "#cbd5e1" }}>
          <tbody>
            <tr><td>Name</td><td>{selected.incharge_name}</td></tr>
            <tr><td>Designation</td><td>{selected.designation}</td></tr>
            <tr><td>Mobile</td><td>{selected.incharge_mobile}</td></tr>
            <tr><td>Email</td><td>{selected.incharge_email}</td></tr>
            <tr><td>Gender</td><td>{selected.gender}</td></tr>
            <tr><td>DOB</td><td>{selected.dob}</td></tr>
          </tbody>
        </table>

        {/* DOCUMENTS */}
        <h6 className="fw-bold mt-3">Documents</h6>

        <ul style={{ columns: 2 }}>
          {selected.voter_card && <li>Voter Card ✔</li>}
          {selected.pan_card && <li>PAN Card ✔</li>}
          {selected.trade_license && <li>Trade License ✔</li>}
          {selected.inside_photo && <li>Inside Photo ✔</li>}
          {selected.outside_photo && <li>Outside Photo ✔</li>}
          {selected.theory_room && <li>Theory Room ✔</li>}
          {selected.practical_room && <li>Practical Room ✔</li>}
        </ul>

        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(3, 1fr)",
            gap: "10px",
            marginTop: "10px"
          }}
        >
          {[
            "voter_card",
            "pan_card",
            "trade_license",
            "inside_photo",
            "outside_photo",
            "theory_room",
            "practical_room"
          ].map((img, i) =>
            selected[img] && (
              <img
                key={i}
                src={`${API}/uploads/${selected[img]}`}
                style={{ width: "100px", border: "1px solid #ccc" }}
              />
            )
          )}
        </div>

        {/* FOOTER */}
        <p className="mt-4">
          I declare that all information is correct. Kindly approve my application.
        </p>

        <div style={{ marginTop: "50px", textAlign: "right" }}>
          {selected.signature && (
            <img
              src={`${API}/uploads/${selected.signature}`}
              style={{ width: "120px" }}
            />
          )}
          <p><b>Applicant Signature</b></p>
        </div>

      </div>

      {/* BUTTONS */}
      <div className="d-flex gap-2 mt-3">

        <button
          className="btn btn-primary btn-sm"
          onClick={handlePrint}
        >
          Print
        </button>

        <button
          className="btn btn-success btn-sm"
          onClick={handleDownload}
        >
          Download PDF
        </button>

        <button
          className="btn btn-secondary btn-sm ms-auto"
          onClick={() => {
            setShowView(false);
            setSelected(null);
          }}
        >
          Close
        </button>

      </div>

    </div>
  </div>
)}
        {/* 🔥 ACTION MODAL */}
        {showAction && selected && (
            <div
              style={modalStyle}
              onClick={() => {
                setShowView(false);
                setSelected(null);
              }}
            >
                <div style={{ ...modalContent, width: "300px", textAlign: "center" }}>

                <h5>Take Action</h5>

                <button
                    className="btn btn-success btn-sm w-100 mb-2"
                    onClick={() => approve(selected.id)}
                >
                    Approve
                </button>

                <button
                    className="btn btn-warning btn-sm w-100 mb-2"
                    onClick={() => updateStatus(selected.id, "hold")}
                >
                    Hold
                </button>

                <button
                    className="btn btn-danger btn-sm w-100 mb-2"
                    onClick={() => updateStatus(selected.id, "rejected")}
                >
                    Reject
                </button>

                <button
                    className="btn btn-secondary btn-sm w-100"
                    onClick={() => setShowAction(false)}
                >
                    Cancel
                </button>

                </div>
            </div>
            )}

        {/* 🔥 EDIT MODAL */}
        {showEdit && (
            <div
              style={modalStyle}
              onClick={() => {
                setShowEdit(false);
                setEditFiles({});
                setEditPreviews({});
                setBrokenPreviews({});
              }}
            >
                <div style={{ ...modalContent, width: "760px" }} onClick={(e) => e.stopPropagation()}>
                  

                <h5>Edit Application</h5>

                <div className="row g-2">
                  <div className="col-md-6">
                    <label className="form-label">Institute Name</label>
                    <input name="institute_name" value={editData.institute_name || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Academy Category</label>
                    <select name="academy_category" value={editData.academy_category || ""} onChange={handleEditChange} className="form-control">
                      <option value="">Select Category</option>
                      {academyCategories.map((c) => (<option key={c} value={c}>{c}</option>))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">State</label>
                    <select name="state_id" value={editData.state_id || ""} onChange={handleEditChange} className="form-control">
                      <option value="">Select State</option>
                      {states.map((s) => (<option key={s.id} value={s.id}>{s.name}</option>))}
                    </select>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">District</label>
                    <select name="district_id" value={editData.district_id || ""} onChange={handleEditChange} className="form-control">
                      <option value="">Select District</option>
                      {districts.filter((d) => String(d.state_id) === String(editData.state_id || "")).map((d) => (<option key={d.id} value={d.id}>{d.name}</option>))}
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">City</label>
                    <input name="city" value={editData.city || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Pincode</label>
                    <input name="pincode" value={editData.pincode || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Contact</label>
                    <input name="contact" value={editData.contact || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-12">
                    <label className="form-label">Address</label>
                    <textarea name="address" value={editData.address || ""} onChange={handleEditChange} className="form-control" rows="2"></textarea>
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Email</label>
                    <input name="email" value={editData.email || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Incharge Name</label>
                    <input name="incharge_name" value={editData.incharge_name || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Designation</label>
                    <input name="designation" value={editData.designation || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">Gender</label>
                    <select name="gender" value={editData.gender || ""} onChange={handleEditChange} className="form-control">
                      <option value="">Select</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">DOB</label>
                    <input type="date" name="dob" value={editData.dob || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Incharge Mobile</label>
                    <input name="incharge_mobile" value={editData.incharge_mobile || ""} onChange={handleEditChange} className="form-control" />
                  </div>
                  <div className="col-md-6">
                    <label className="form-label">Incharge Email</label>
                    <input name="incharge_email" value={editData.incharge_email || ""} onChange={handleEditChange} className="form-control" />
                  </div>

                  <div className="col-12 mt-2">
                    <div className="alert alert-info py-2 mb-2">
                      Document/Image Update (optional): jeta change korben sudhu oi file select korun.
                    </div>
                  </div>
                  {[
                    ["photo", "Photo"],
                    ["signature", "Signature"],
                    ["voter_card", "Voter Card"],
                    ["pan_card", "PAN Card"],
                    ["trade_license", "Trade License"],
                    ["inside_photo", "Inside Photo"],
                    ["outside_photo", "Outside Photo"],
                    ["theory_room", "Theory Room"],
                    ["practical_room", "Practical Room"],
                  ].map(([key, label]) => {
                    const selectedFile = editFiles[key];
                    const selectedPreview = editPreviews[key];
                    const existingName = editData[key];
                    const existingUrl = uploadCandidates(existingName)[0] || "";
                    const showPreviewImage = selectedFile
                      ? (String(selectedFile.type || "").startsWith("image/") || isImageFile(selectedFile.name))
                      : isImageFile(existingName);
                    const previewUrl = selectedFile ? selectedPreview : existingUrl;

                    return (
                      <div className="col-md-6" key={key}>
                        <label className="form-label">{label}</label>
                        <input type="file" name={key} className="form-control" onChange={handleEditFile} />
                        <div className="mt-2 small text-muted">
                          {selectedFile ? `Selected: ${selectedFile.name}` : existingName ? `Current: ${existingName}` : "No file uploaded"}
                        </div>
                        {previewUrl ? (
                          showPreviewImage ? (
                            <img
                              src={previewUrl}
                              alt={label}
                              onLoad={() => setBrokenPreviews((prev) => ({ ...prev, [key]: false }))}
                              onError={(e) => {
                                if (selectedFile) {
                                  setBrokenPreviews((prev) => ({ ...prev, [key]: true }));
                                  e.currentTarget.style.display = "none";
                                  return;
                                }
                                const list = uploadCandidates(existingName);
                                const current = e.currentTarget.getAttribute("src");
                                const idx = list.indexOf(current);
                                const next = idx >= 0 ? list[idx + 1] : null;
                                if (next) {
                                  e.currentTarget.setAttribute("src", next);
                                } else {
                                  setBrokenPreviews((prev) => ({ ...prev, [key]: true }));
                                  e.currentTarget.style.display = "none";
                                }
                              }}
                              style={{ width: "100%", maxHeight: "130px", objectFit: "contain", marginTop: "6px", border: "1px solid #ddd", borderRadius: "6px" }}
                            />
                          ) : (
                            <div className="small text-secondary mt-1">
                              Preview not available for this file type.
                            </div>
                          )
                        ) : null}
                      </div>
                    );
                  })}
                </div>
                <div className="d-flex gap-2 mt-3">
                  <button className="btn btn-success flex-fill" onClick={updateData}>
                    Save
                  </button>
                  <button
                    className="btn btn-secondary flex-fill"
                    onClick={() => {
                      setShowEdit(false);
                      setEditFiles({});
                      setEditPreviews({});
                      setBrokenPreviews({});
                    }}
                  >
                    Close
                  </button>
                </div>

                </div>
            </div>
            )}

      </div>

    </DashboardLayout>
  );
}

export default NewFranchise;



